<template>
    <div :class="{ 'cursor-pointer': !props.disabled }">
        <q-chip :color="estadoColor" text-color="white" size="sm">
            {{ modelValue }}
        </q-chip>
        <q-menu v-if="!props.disabled" transition-show="jump-down" transition-hide="jump-up">
            <q-list style="min-width: 100px">
                <template v-for="e in estados" :key="e.value">
                    <q-item clickable v-close-popup @click="confirmationDialog(e)">
                        <q-item-section avatar>
                            <q-icon :color="e.color" name="mdi-square" />
                        </q-item-section>
                        <q-item-section>{{ e.label }}</q-item-section>
                    </q-item>
                </template>
            </q-list>
        </q-menu>

        <q-inner-loading :showing="loading">
            <q-spinner />
        </q-inner-loading>
    </div>
</template>

<script setup>
import PresupuestoService from '@/services/PresupuestoService.js';
import { ref, computed } from 'vue';

import { useDefaultDataStore } from '@/stores/useDefaultDataStore';
import { useQuasar } from 'quasar';
import { flow } from 'lodash';


const loading = ref(false);
const $q = useQuasar();
const defaultDataStore = useDefaultDataStore();
const props = defineProps({
    modelValue: [String, Number],
    presupuesto: [String, Number],
    disabled: {
        type: Boolean,
        default: false,
    },
    flow: {
        type: Boolean,
        default: false,
    },
});
const emit = defineEmits(['update:modelValue', 'updated']);
const estados = computed(() => {
    return props.flow ? defaultDataStore.getSelectEstadosFlow(props.modelValue) : defaultDataStore.getSelectEstados;
});
const confirmationDialog = (e) => {
    $q.dialog({
        title: 'Confirmar',
        message: 'Confirma el cambio de estado?',
        cancel: true,
        persistent: true,
    })
        .onOk(async () => {
            loading.value = true;
            await presupuestoUpdate(e);
        })
        .onCancel(() => {
            // console.log('>>>> Cancel')
        })
        .onDismiss(() => {
            // console.log('I am triggered on both OK and Cancel')
        });
};
const presupuestoUpdate = async (estado) => {
    try {
        const { nuevoEstado } = await PresupuestoService.estadoUpdate(props.presupuesto, estado.value);
        emit('updated', nuevoEstado.id);
        emit('update:modelValue', nuevoEstado.nombre);
    } catch (error) {
        if (error && error.data && error.data.nuevoEstado) {
            const nuevoEstado = error.data.nuevoEstado;
            emit('updated', nuevoEstado.id);
            emit('update:modelValue', nuevoEstado.nombre);
        }
        console.error('Error updating presupuesto:', error);
    } finally {
        loading.value = false;
    }
};
const estadoColor = computed(() => {
    return defaultDataStore?.getEstadoColor(props.modelValue);
});
</script>
